<script>
export let text = "Simulator de alegeri";
</script>

<span>{text}</span>